import { createPortal } from "react-dom";
import { Icon } from "@/components/Icon";
import { TgEmoji } from "@/components/TgEmoji";
import { PopupCloseButton } from "@/components/PopupClose";
import { popupActionsCol, popupBtnPrimary } from "@/lib/popupButtons";
import { tg } from "@/lib/telegram";
import { openTelegramChat } from "@/lib/openExternal";

const SUPPORT_URL = "https://t.me/inflow_manager";

/**
 * Попап підтримки (відкривається кнопкою-навушниками на головній).
 *
 * Один шлях — написати в підтримку (owner 2026-08-23). AI-чат усередині
 * застосунку прибрано: підтримку веде AI прямо в лічці акаунта @inflow_manager,
 * тому окремий чат у мініаппі лише плутав.
 */
export function SupportPopup({ onClose }: { onClose: () => void }) {
  const handleLive = () => {
    // openTelegramLink мертвий на macOS (кнопка нічого не робила) — йдемо через
    // openTelegramChat (window.open), owner 2026-07-23.
    tg()?.HapticFeedback?.impactOccurred?.("light");
    openTelegramChat(SUPPORT_URL);
  };

  const modal = (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height:
          typeof window !== "undefined" &&
          (window as any).Telegram?.WebApp?.viewportStableHeight
            ? `${(window as any).Telegram.WebApp.viewportStableHeight}px`
            : "100vh",
      }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-md bg-surface rounded-3xl p-5 shadow-2xl overflow-y-auto"
        style={{ maxHeight: "calc(100% - 32px)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Хрестик закриття (юзер 2026-06-13: три кнопки підряд перевантажують
            — лишаємо хрестик зверху, нижню «Закрити» прибрано). */}
        <PopupCloseButton onClose={onClose} />
        <div className="text-center mb-4">
          <div className="mb-2 flex justify-center">
            <TgEmoji char="📨" size={44} />
          </div>
          <div className="font-display text-[1.125rem] font-bold text-ink leading-tight">
            Підтримка inFLOW
          </div>
          <div className="text-[0.78125rem] text-ink-dim mt-1.5 leading-relaxed [text-wrap:balance]">
            Є питання про підписку, оплату чи вакансії? Напиши нам — швидко
            відповімо і розберемось разом.
          </div>
        </div>

        <div className={popupActionsCol}>
          <button type="button" onClick={handleLive} className={popupBtnPrimary}>
            <Icon name="chat" size={16} color="#fff" />
            <span className="leading-none">Написати в підтримку</span>
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
